import React from "react";
import CheckoutProductPricesPickers from "components/CheckoutProductPricesPickers";
import { useFormikContext } from "formik";
import SectionBezel from "components/SectionBezel";
import { getIconForUID } from "components/FormerEditor/utils";
import { useMessagesError } from "utils/hooks/editor";
import { STATE_KEYS } from "utils/constants/state";

const ProductsFields = ({ inherited }) => {
  const { values } = useFormikContext();
  const canEdit = !Boolean(values.id);
  const LockIcon = getIconForUID("lock");
  const locked = !canEdit && <LockIcon size={18} />;
  const error = useMessagesError(STATE_KEYS.SHORT_LINK.PRIMARIES);

  return (
    <SectionBezel
      header="Products"
      action={locked}
      expandable
      open
      error={error}
    >
      <CheckoutProductPricesPickers
        rootPath="data.product"
        name="primaries"
        editMode={canEdit}
        inherited={inherited}
      />
    </SectionBezel>
  );
};

export default ProductsFields;
